/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 返回次品问题类型附加信息 的 **请求配置**
 *
 * @分类 仓储API
 * @请求头 `POST /erp/Common/getStockProblemTypeInfo`
 */
const postGetStockProblemTypeInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Common/getStockProblemTypeInfo",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetStockProblemTypeInfo",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 返回次品问题类型附加信息 的 **请求函数**
 *
 * @分类 仓储API
 * @请求头 `POST /erp/Common/getStockProblemTypeInfo`
 */
export const postGetStockProblemTypeInfo = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetStockProblemTypeInfoRequestConfig, requestData),
    ...args
  );
};
postGetStockProblemTypeInfo.requestConfig =
  postGetStockProblemTypeInfoRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 获取供应商城市 的 **请求配置**
 *
 * @分类 商家API
 * @请求头 `GET /erp/Common/getCityList`
 */
const getGetCityListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/Common/getCityList",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetCityList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取供应商城市 的 **请求函数**
 *
 * @分类 商家API
 * @请求头 `GET /erp/Common/getCityList`
 */
export const getGetCityList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getGetCityListRequestConfig, requestData), ...args);
};
getGetCityList.requestConfig = getGetCityListRequestConfig;
const mockUrl_0_0_0_2 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_2 = "";
const prodUrl_0_0_0_2 = "";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 选择供应商 的 **请求配置**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/Common/selectSupply`
 */
const postSelectSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Common/selectSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSelectSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 选择供应商 的 **请求函数**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/Common/selectSupply`
 */
export const postSelectSupply = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postSelectSupplyRequestConfig, requestData), ...args);
};
postSelectSupply.requestConfig = postSelectSupplyRequestConfig;
const mockUrl_0_0_0_3 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_3 = "";
const prodUrl_0_0_0_3 = "";
const dataKey_0_0_0_3 = "data";
/**
 * 接口 业绩归属市场筛选项 的 **请求配置**
 *
 * @分类 商家API/业绩归属市场
 * @请求头 `POST /erp/Common/getAttributeMarketList`
 */
const postGetAttributeMarketListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/Common/getAttributeMarketList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetAttributeMarketList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 业绩归属市场筛选项 的 **请求函数**
 *
 * @分类 商家API/业绩归属市场
 * @请求头 `POST /erp/Common/getAttributeMarketList`
 */
export const postGetAttributeMarketList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetAttributeMarketListRequestConfig, requestData),
    ...args
  );
};
postGetAttributeMarketList.requestConfig =
  postGetAttributeMarketListRequestConfig;
const mockUrl_0_0_0_4 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_4 = "";
const prodUrl_0_0_0_4 = "";
const dataKey_0_0_0_4 = "data";
/**
 * 接口 根据买手组id获取买手组人员 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getPickerGroupMember`
 */
const postGetPickerGroupMemberRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/getPickerGroupMember",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetPickerGroupMember",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 根据买手组id获取买手组人员 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getPickerGroupMember`
 */
export const postGetPickerGroupMember = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetPickerGroupMemberRequestConfig, requestData),
    ...args
  );
};
postGetPickerGroupMember.requestConfig = postGetPickerGroupMemberRequestConfig;
/**
 * 接口 入库来源信息 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/selectStockSource`
 */
const postSelectStockSourceRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/selectStockSource",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSelectStockSource",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 入库来源信息 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/selectStockSource`
 */
export const postSelectStockSource = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSelectStockSourceRequestConfig, requestData),
    ...args
  );
};
postSelectStockSource.requestConfig = postSelectStockSourceRequestConfig;
/**
 * 接口 一级市场 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getFirstMarketList`
 */
const postGetFirstMarketListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/getFirstMarketList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetFirstMarketList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 一级市场 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getFirstMarketList`
 */
export const postGetFirstMarketList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetFirstMarketListRequestConfig, requestData),
    ...args
  );
};
postGetFirstMarketList.requestConfig = postGetFirstMarketListRequestConfig;
/**
 * 接口 二级子市场 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getSubMarketList`
 */
const postGetSubMarketListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/getSubMarketList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetSubMarketList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 二级子市场 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getSubMarketList`
 */
export const postGetSubMarketList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetSubMarketListRequestConfig, requestData),
    ...args
  );
};
postGetSubMarketList.requestConfig = postGetSubMarketListRequestConfig;
/**
 * 接口 供应商搜索 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/fetchSupplyBySearchByPage`
 */
const postFetchSupplyBySearchByPageRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/fetchSupplyBySearchByPage",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postFetchSupplyBySearchByPage",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 供应商搜索 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/fetchSupplyBySearchByPage`
 */
export const postFetchSupplyBySearchByPage = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postFetchSupplyBySearchByPageRequestConfig, requestData),
    ...args
  );
};
postFetchSupplyBySearchByPage.requestConfig =
  postFetchSupplyBySearchByPageRequestConfig;
/**
 * 接口 开户银行列表 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `GET /erp/Common/getBankList`
 */
const getGetBankListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/getBankList",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetBankList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 开户银行列表 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `GET /erp/Common/getBankList`
 */
export const getGetBankList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getGetBankListRequestConfig, requestData), ...args);
};
getGetBankList.requestConfig = getGetBankListRequestConfig;
/**
 * 接口 获取ERP菜单内容 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getErpMenu`
 */
const postGetErpMenuRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/getErpMenu",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetErpMenu",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取ERP菜单内容 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getErpMenu`
 */
export const postGetErpMenu = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetErpMenuRequestConfig, requestData), ...args);
};
postGetErpMenu.requestConfig = postGetErpMenuRequestConfig;
/**
 * 接口 获取供应商列表 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/fetchSupplyBySearch`
 */
const postFetchSupplyBySearchRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/fetchSupplyBySearch",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postFetchSupplyBySearch",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取供应商列表 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/fetchSupplyBySearch`
 */
export const postFetchSupplyBySearch = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postFetchSupplyBySearchRequestConfig, requestData),
    ...args
  );
};
postFetchSupplyBySearch.requestConfig = postFetchSupplyBySearchRequestConfig;
/**
 * 接口 获取地级县 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getDistrict`
 */
const postGetDistrictRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/getDistrict",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetDistrict",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取地级县 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getDistrict`
 */
export const postGetDistrict = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetDistrictRequestConfig, requestData), ...args);
};
postGetDistrict.requestConfig = postGetDistrictRequestConfig;
/**
 * 接口 获取地级市 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getCity`
 */
const postGetCityRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/getCity",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetCity",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取地级市 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getCity`
 */
export const postGetCity = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetCityRequestConfig, requestData), ...args);
};
postGetCity.requestConfig = postGetCityRequestConfig;
/**
 * 接口 获取市场列表 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `GET /erp/Common/getMarketList`
 */
const getGetMarketListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/getMarketList",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetMarketList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取市场列表 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `GET /erp/Common/getMarketList`
 */
export const getGetMarketList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getGetMarketListRequestConfig, requestData), ...args);
};
getGetMarketList.requestConfig = getGetMarketListRequestConfig;
/**
 * 接口 获取快递公司信息 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `GET /erp/Common/getShippingCompany`
 */
const getGetShippingCompanyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/getShippingCompany",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetShippingCompany",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取快递公司信息 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `GET /erp/Common/getShippingCompany`
 */
export const getGetShippingCompany = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getGetShippingCompanyRequestConfig, requestData),
    ...args
  );
};
getGetShippingCompany.requestConfig = getGetShippingCompanyRequestConfig;
/**
 * 接口 获取快递网点 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getShippingSender`
 */
const postGetShippingSenderRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/getShippingSender",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetShippingSender",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取快递网点 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getShippingSender`
 */
export const postGetShippingSender = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetShippingSenderRequestConfig, requestData),
    ...args
  );
};
postGetShippingSender.requestConfig = postGetShippingSenderRequestConfig;
/**
 * 接口 获取省 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `GET /erp/Common/getProvince`
 */
const getGetProvinceRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/getProvince",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetProvince",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取省 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `GET /erp/Common/getProvince`
 */
export const getGetProvince = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getGetProvinceRequestConfig, requestData), ...args);
};
getGetProvince.requestConfig = getGetProvinceRequestConfig;
/**
 * 接口 获取采购员信息 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getPurchaseMember`
 */
const postGetPurchaseMemberRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/getPurchaseMember",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetPurchaseMember",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取采购员信息 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getPurchaseMember`
 */
export const postGetPurchaseMember = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetPurchaseMemberRequestConfig, requestData),
    ...args
  );
};
postGetPurchaseMember.requestConfig = postGetPurchaseMemberRequestConfig;
/**
 * 接口 获取采购组 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `GET /erp/Common/selectPg`
 */
const getSelectPgRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/selectPg",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: ["is_use"],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getSelectPg",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取采购组 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `GET /erp/Common/selectPg`
 */
export const getSelectPg = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getSelectPgRequestConfig, requestData), ...args);
};
getSelectPg.requestConfig = getSelectPgRequestConfig;
/**
 * 接口 获取采购组下的采购员 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getPgMember`
 */
const postGetPgMemberRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/getPgMember",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetPgMember",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取采购组下的采购员 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getPgMember`
 */
export const postGetPgMember = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetPgMemberRequestConfig, requestData), ...args);
};
postGetPgMember.requestConfig = postGetPgMemberRequestConfig;
/**
 * 接口 获取质检次品类型数组 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `GET /erp/Common/getCpCategoryClass`
 */
const getGetCpCategoryClassRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/getCpCategoryClass",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetCpCategoryClass",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取质检次品类型数组 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `GET /erp/Common/getCpCategoryClass`
 */
export const getGetCpCategoryClass = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getGetCpCategoryClassRequestConfig, requestData),
    ...args
  );
};
getGetCpCategoryClass.requestConfig = getGetCpCategoryClassRequestConfig;
/**
 * 接口 获取次品尺寸数据 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `GET /erp/Common/getCpSizeData`
 */
const getGetCpSizeDataRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/getCpSizeData",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetCpSizeData",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取次品尺寸数据 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `GET /erp/Common/getCpSizeData`
 */
export const getGetCpSizeData = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getGetCpSizeDataRequestConfig, requestData), ...args);
};
getGetCpSizeData.requestConfig = getGetCpSizeDataRequestConfig;
/**
 * 接口 选择打标类型 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/selectDBRecordType`
 */
const postSelectDbRecordTypeRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/selectDBRecordType",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSelectDbRecordType",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 选择打标类型 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/selectDBRecordType`
 */
export const postSelectDbRecordType = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSelectDbRecordTypeRequestConfig, requestData),
    ...args
  );
};
postSelectDbRecordType.requestConfig = postSelectDbRecordTypeRequestConfig;
/**
 * 接口 获取启用次品组下拉列表 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getDgGroup`
 */
const postGetDgGroupRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/getDgGroup",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetDgGroup",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取启用次品组下拉列表 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getDgGroup`
 */
export const postGetDgGroup = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetDgGroupRequestConfig, requestData), ...args);
};
postGetDgGroup.requestConfig = postGetDgGroupRequestConfig;
/**
 * 接口 获取用户波次属性选项 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `GET /erp/Common/getWaveTypeAttr`
 */
const getGetWaveTypeAttrRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/getWaveTypeAttr",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetWaveTypeAttr",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取用户波次属性选项 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `GET /erp/Common/getWaveTypeAttr`
 */
export const getGetWaveTypeAttr = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getGetWaveTypeAttrRequestConfig, requestData),
    ...args
  );
};
getGetWaveTypeAttr.requestConfig = getGetWaveTypeAttrRequestConfig;
/**
 * 接口 根据商家ID获取商家可配置的货期配置 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getDeliveryDaySettingBySupplyId`
 */
const postGetDeliveryDaySettingBySupplyIdRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/getDeliveryDaySettingBySupplyId",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetDeliveryDaySettingBySupplyId",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 根据商家ID获取商家可配置的货期配置 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/getDeliveryDaySettingBySupplyId`
 */
export const postGetDeliveryDaySettingBySupplyId = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetDeliveryDaySettingBySupplyIdRequestConfig, requestData),
    ...args
  );
};
postGetDeliveryDaySettingBySupplyId.requestConfig =
  postGetDeliveryDaySettingBySupplyIdRequestConfig;
/**
 * 接口 查询买手组 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/selectPicker`
 */
const postSelectPickerRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Common/selectPicker",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSelectPicker",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 查询买手组 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/Common/selectPicker`
 */
export const postSelectPicker = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postSelectPickerRequestConfig, requestData), ...args);
};
postSelectPicker.requestConfig = postSelectPickerRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/common.js